import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { createFilingSourceCitationAttributes, filingSourceCitationContent } from './attributes';
import { FilingSourceCitationComponent } from './component';

export const FilingSourceCitation = Node.create({
    name: 'filingSourceCitation',
    group: 'inline',
    inline: true,
    atom: true,
    draggable: false,
    selectable: false,

    addAttributes() {
        return createFilingSourceCitationAttributes();
    },

    parseHTML() {
        return [
            {
                tag: 'a.filing-source-button',
                priority: 1000,
            },
        ];
    },

    renderHTML({ HTMLAttributes, node }) {
        const company = String(node.attrs.company || 'SEC Filing');
        const filing = String(node.attrs.filing || 'Filing');

        return [
            'a',
            mergeAttributes(HTMLAttributes, { class: 'filing-source-button', 'data-filing-source': 'true' }),
            ...filingSourceCitationContent(company, filing),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(FilingSourceCitationComponent);
    },
});
